import React, { Component } from "react";
import NavEN from "../Symbols/NavEN";
import FooterEN from "../Symbols/FooterEN";
import { Helmet } from "react-helmet-async";
import "../../stylesheets/AboutUs.css";

class EnvironmentEN extends Component {
  constructor(props) {
    super(props);
    this.state = {
      docs: [],
    }
    this.intro = React.createRef();
  }

  componentDidMount() {
    this.fetchData();
  }

  fetchData = async () => {
    let count = 1;
    let records = [];
    for (let i = 0; i < count; i++) {
      const response = await fetch(
        `https://api.airtable.com/v0/appiUuQajhQ6Drt6x/Docs?view=Sorted`, { headers: { 'Authorization': 'Bearer patSxqK40aDpd0iY6.beedbae8aef0d8ef37eaa0268af4654eb5113643efb69777ef67367c2031ee09' } }
      );
      const data = await response.json();
      records = records.concat(data.records);
    }
    this.setState({
      docs: records,
    });
  };

  introScroll = () => {
    let element = this.intro.current;
    let headerOffset = 45;
    let elementPosition = element.getBoundingClientRect().top;
    let offsetPosition = elementPosition + window.pageYOffset - headerOffset;

    window.scrollTo({
      top: offsetPosition,
      behavior: "smooth",
    });
  };

  render() {
    return (
      <div className="content">
        <Helmet>
          <title>Pancon - Environment</title>
          <meta
            name="description"
            content="Discover the quality certificates from Pancon like IATF 16949, RoHS conformity, ISO 9001, ... - your partner for certified
certified connectors and connection solutions to the highest standards.
Trust in tested quality for automotive and industry."
          />
          <meta property="og:title" content="Pancon - Environment" />
          <meta
            property="og:description"
            content="Discover the quality certificates from Pancon like IATF 16949, RoHS conformity, ISO 9001, ... - your partner for certified
certified connectors and connection solutions to the highest standards.
Trust in tested quality for automotive and industry."
          />
          <link
            rel="alternate"
            href="https://www.pancon.de/de/umwelt"
            hrefLang="de"
          ></link>
          <link
            rel="alternate"
            href="https://www.pancon.de/en/environment"
            hrefLang="en"
          ></link>
        </Helmet>
        <NavEN />
        <div className="hero env">
          <div className="red-bg-hero"></div>
          <div className="hero-content">
            <h1 className="hero-heading">Environment</h1>
            <p className="hero-desc">Overview of our certificates</p>
            <button onClick={this.introScroll} className="default inverted">
              Learn more
            </button>
          </div>
        </div>
        <div
          ref={this.intro}
          id="intro"
          className="section first flex center-h"
        >
          <div className="medium flex">
            <div className="heading1-cont flex center-v">
              <div className="heading-deco m-right-3"></div>
              <h2>REACH</h2>
            </div>
            <div className="half">
              <h4>Description</h4>
              <p className="body">
                Registration, Evaluation, Authorisation and Restriction of
                Chemicals (REACH) is a European Union Regulation of 18 December
                2006. REACH addresses the production and use of chemical
                substances, and their potential impacts on both human health and
                the environment
              </p>
              <a href={this.state.docs[0] ? this.state.docs[0].fields.Document_EN[0].url : ""} target={"_blank"} className="default env">
                Download
              </a>
            </div>
            <div className="half right-text">
              <h4>Further information</h4>
              <p className="body">
                <ul>
                  <li>
                    The{" "}
                    <a
                      target={"_blank"}
                      href="http://echa.europa.eu/de/"
                      className="accented"
                    >
                      Europäische Chemikalienagentur
                    </a>{" "}
                    (ECHA) is an agency of the European Union which manages the
                    technical, scientific and administrative aspects of the
                    Registration, Evaluation, Authorisation and Restriction of
                    Chemicals (REACH) system.
                  </li>
                  <li>
                    BDI - Bundesverband der Deutschen Industrie REACH- und der
                    CLP-Verordnung als{" "}
                    <a
                      target={"_blank"}
                      href="http://echa.europa.eu/de/"
                      className="accented"
                    >
                      BDI-Broschüre
                    </a>
                    .
                  </li>
                </ul>
              </p>
            </div>
          </div>
        </div>
        <div className="section full env flex center-h center-v">
          <span className="bg-quote">
            "Look deep into nature, and then you will understand everything
            better."
          </span>
        </div>
        <div id="coc" className="section flex center-h">
          <div className="medium flex">
            <div className="heading1-cont flex center-v">
              <div className="heading-deco m-right-3"></div>
              <h2>Code of Conduct</h2>
            </div>
            <div>
              <a href={this.state.docs[0] ? this.state.docs[1].fields.Document_EN[0].url : ""} target={"_blank"} className="default env">
                Download
              </a>
            </div>
          </div>
        </div>
        <div id="rohs" className="section flex center-h">
          <div className="medium flex">
            <div className="heading1-cont flex center-v">
              <div className="heading-deco m-right-3"></div>
              <h2>RoHS I / RoHS II</h2>
            </div>
            <div className="half">
              <h4>Description</h4>
              <p className="body">
                The Directive on the restriction of the use of certain hazardous
                substances in electrical and electronic equipment 2002/95/EC &
                2011/65/EC (RoHS).
              </p>
              <a href={this.state.docs[0] ? this.state.docs[2].fields.Document_EN[0].url : ""} target={"_blank"} className="default env">
                Download
              </a>
            </div>
            <div className="half right-text">
              <h4>Further information</h4>
              <p className="body">
                <ul>
                  <li>
                    <a
                      target={"_blank"}
                      href="http://ec.europa.eu/environment/waste/rohs_eee/index_en.htm"
                      className="accented"
                    >
                      European Commission Environment Waste RoHS
                    </a>
                  </li>
                </ul>
              </p>
            </div>
          </div>
        </div>
        <div id="iatf-iso" className="section flex center-h">
          <div className="medium flex">
            <div className="heading1-cont flex center-v">
              <div className="heading-deco m-right-3"></div>
              <h2>Additional certificates</h2>
            </div>
            <div className="third">
              <h4>IATF 16949</h4>
              <a href={this.state.docs[0] ? this.state.docs[3].fields.Document_EN[0].url : ""} target={"_blank"} className="default env">
                Download
              </a>
            </div>
            <div className="third">
              <h4>ISO 9001</h4>
              <a href={this.state.docs[0] ? this.state.docs[4].fields.Document_EN[0].url : ""} target={"_blank"} className="default env">
                Download
              </a>
            </div>
            <div className="third">
              <h4>Notice of Publication</h4>
              <a href={this.state.docs[0] ? this.state.docs[5].fields.Document_EN[0].url : ""} target={"_blank"} className="default env">
                Download
              </a>
            </div>
          </div>
        </div>
        <FooterEN />
      </div>
    );
  }
}

export default EnvironmentEN;
